export const USER_OTP_RENEWAL_TYPES = {
  FORGOT_PASSWORD: 'forgot password',
  REGISTER: 'register',
}
